<template>
  <div>
    <v-form ref="forminputMarker">
      <v-dialog v-model="defaultTitle" class="px-5" max-width="500" persistent>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title> متن آماده</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark icon @click="defaultTitle = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="pt-5">
            <v-autocomplete
              :id="texts.id"
              :items="texts"
              chips
              deletable-chips
              item-text="title"
              label="متن پیشفرض"
              prepend-inner-icon="fa fa-pencil-alt"
              @input="setTitle"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="text-capitalize">
                      {{ index }} - {{ data.item.title }} -
                      {{ data.item.category }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-autocomplete
              :id="Ads.id"
              :items="Ads"
              chips
              deletable-chips
              item-text="title"
              label="آگهی پیشفرض"
              prepend-inner-icon="fa fa-pencil-alt"
              @input="setTitle"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-capitalize">
                      {{ index }} - {{ data.item.title }}</span
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="getText" class="px-5" max-width="500" persistent>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>
              <div class="row">
                <span class="text-right col-md"> متن و عنوان غیرتکراری</span>

                <span v-if="expireTime !== ''" class="float-left col-md mr-11"
                  >زمان باقی مانده :
                  {{ parseInt(expireTime / 60) + ":" + (expireTime % 60) }}
                </span>
              </div>
            </v-toolbar-title>
            <v-spacer />

            <v-toolbar-items>
              <v-btn dark icon @click="delOptions">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="pt-5">
            <v-text-field
              v-model="jobKeyword"
              :error-messages="productMessage"
              clear-icon="mdi-close-circle-outline"
              clearable
              dense
              label="نام محصول / خدمات"
              outlined
            ></v-text-field>
            <v-btn
              v-if="productMessage === '' && jobKeyword !== ''"
              class="btn-dec-with-text ml-auto"
              @click="getSuggest"
            >
              <span class="fa fa-save ml-1" style="font-size: 1.2rem"></span>
              ثبت پیشنهادات
            </v-btn>
            <v-autocomplete
              v-if="suggestTexts.titles != null"
              :items="suggestTexts.titles"
              chips
              deletable-chips
              label="عنوان پیشنهادی"
              prepend-inner-icon="fa fa-pencil-alt"
              @change="authenticate"
              @input="setTitle"
            />
            <v-autocomplete
              v-if="suggestTexts.descriptions !== null"
              :items="suggestTexts.descriptions"
              chips
              deletable-chips
              label="توضیحات پیشنهادی"
              prepend-inner-icon="fa fa-pencil-alt"
              @input="setDescription"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="defaultDesc" class="px-5" max-width="500" persistent>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title> متن آماده</v-toolbar-title>
            <v-spacer />

            <v-toolbar-items>
              <v-btn dark icon @click="defaultDesc = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="pt-5">
            <v-autocomplete
              :id="textsDesc.id"
              :items="textsDesc"
              chips
              deletable-chips
              item-text="description"
              label="متن پیشفرض"
              prepend-inner-icon="fa fa-pencil-alt"
              @input="setDescription"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="text-capitalize">
                      {{ index }} - {{ data.item.description }} -
                      {{ data.item.category }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-autocomplete
              :id="Ads.id"
              :items="Ads"
              chips
              deletable-chips
              item-text="description"
              label="آگهی پیشفرض"
              prepend-inner-icon="fa fa-pencil-alt"
              @input="setDescription"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-capitalize">
                      {{ index }} - {{ data.item.description }}</span
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-col
        v-for="(item, index) in properties"
        v-if="fields.length > 0"
        :key="index"
        :data-name="item.label"
        class="mx-auto pa-0"
        cols="12"
        lg="6"
        md="8"
      >
        <component
          :is="item.name === 'transformable_price' ? 'forRent' : item.component"
          v-if="
            evaluateVisibilityConditions(item.visibility_condition) &&
            item.name !== 'ContactCallMethod' &&
            !(
              item.name === 'Contact_CallEnabled' ||
              item.name === 'Contact_ChatEnabled'
            )
          "
          :key="item.name"
          :append-icon="item.icons[1].icon"
          :append-outer-icon="item.icons[2].icon"
          :counter="enableCounter(item.name)"
          :error-messages="item.errorMessage"
          :hint="item.hint"
          :items="item.items"
          :label="item.label"
          :loading="loading"
          :max="item.counter"
          :maxLength="item.max"
          :min="item.min"
          :multiple="
            ['LightExtra_ColoredParts', 'colored_parts'].includes(item.name) ||
            item.field_type === 'repeated_string'
          "
          :name="item.name"
          :placeholder="item.placeholder"
          :prepend-inner-icon="item.icons[0].icon"
          :required="isRequire(item.required)"
          :rules="item.rules"
          :type="item.type"
          :value="item.value"
          class="rounded-lg"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          item-text="lable"
          item-value="key"
          oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
          outlined
          small-chips
          @change="reload(item.reload, $event, item.name, item.type, item)"
          @input="getValue(item.label, $event, item.name, item.type)"
          @keypress="allowOnlyNumbers($event, item.name, item.type)"
          @click:prepend-inner="item.icons[0].click"
          @click:append-outer="item.icons[2].click"
          @click:append="item.icons[1].click"
        />
        <v-checkbox
          v-if="
            evaluateVisibilityConditions(item.visibility_condition) &&
            item.name !== 'Contact_CallMethod' &&
            (item.name === 'Contact_CallEnabled' ||
              item.name === 'Contact_ChatEnabled')
          "
          :key="item.name"
          :append-icon="item.icons[1].icon"
          :append-outer-icon="item.icons[2].icon"
          :counter="enableCounter(item.name)"
          :error-messages="item.errorMessage"
          :hint="item.hint"
          :items="item.items"
          :label="item.label"
          :loading="loading"
          :max="item.counter"
          :maxLength="item.max"
          :min="item.min"
          :multiple="
            ['LightExtra_ColoredParts', 'colored_parts'].includes(item.name) ||
            item.field_type === 'repeated_string'
          "
          :name="item.name"
          :placeholder="item.placeholder"
          :prepend-inner-icon="item.icons[0].icon"
          :required="isRequire(item.required)"
          :rules="item.rules"
          :type="item.type"
          v-model="parameters[item.name][item.field_type].value"
          class="rounded-lg"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          item-text="lable"
          item-value="key"
          oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
          outlined
          small-chips
          @change="reload(item.reload, $event, item.name, item.type, item)"
          @input="getValue(item.label, $event, item.name, item.type)"
          @keypress="allowOnlyNumbers($event, item.name, item.type)"
          @click:prepend-inner="item.icons[0].click"
          @click:append-outer="item.icons[2].click"
          @click:append="item.icons[1].click"
        ></v-checkbox>
        <v-radio-group
          style="direction: rtl"
          v-if="
            parameters['Contact_CallEnabled']?.boolean?.value &&
            evaluateVisibilityConditions(contactField.visibility_condition) &&
            item.name === 'Contact_CallEnabled'
          "
          v-model="selectedOption"
          :rules="rules"
          :error-messages="errorMessage"
          :label="contactField.title"
          row
          :required="contactField.required"
        >
          <v-radio
            style="text-align: right"
            v-for="option in contactField.options"
            :key="option.value"
            :label="option.display"
            :value="option.value"
          >
            <template v-slot:label>
              <div>
                {{ option.display }}
                <div class="description">{{ option.description }}</div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-sheet
          v-if="emoji === true && item.name === 'title'"
          class="mb-1"
          color="white lighten-3"
          outlined
          rounded
        >
          <v-card-text
            class="py-0 my-0"
            style="background-color: rgba(255, 255, 255, 0.45)"
          >
            <button
              v-for="item in titleEmojies"
              :data-emoji="item"
              class="btn my-1 align-content-center py-1"
              type="button"
              @click="emojiPicker"
            >
              {{ item }}
            </button>
          </v-card-text>
          <v-btn color="error" text @click="emoji = false"
            ><i class="fa fa-times text-danger"></i
          ></v-btn>
        </v-sheet>

        <v-sheet
          v-if="emojidesc === true && item.name === 'description'"
          class="mb-1"
          color="white lighten-3"
          outlined
          rounded
        >
          <v-card-text
            class="py-0 my-0"
            style="background-color: rgba(255, 255, 255, 0.45)"
          >
            <button
              v-for="item in descEmojies"
              :data-emoji="item"
              class="btn my-1 align-content-center py-1"
              type="button"
              @click="emojiPickerdesc"
            >
              {{ item }}
            </button>
          </v-card-text>

          <v-btn color="error" text @click="emojidesc = false"
            ><i class="fa fa-times text-danger"></i
          ></v-btn>
        </v-sheet>
      </v-col>
    </v-form>
  </div>
</template>
<script>
import { Axios2, Bus } from "@/main.js";
import forRent from "../ads/forRent";
import {
  VAutocomplete,
  VSelect,
  VSwitch,
  VTextarea,
  VTextField,
  VCheckbox,
} from "vuetify/lib";
import CategoryPicker from "@/components/pickers/categoryPicker.vue";
import OTPPicker from "@/components/pickers/OTPPicker.vue";
import InputRangePicker from "@/components/pickers/InputRangePicker.vue";

// import videoUploadHandler from "../uploadCenter/videoUploadHandler.vue";
export default {
  name: "inputMaker",

  components: { forRent },

  props: {
    param: {
      type: Object,
      require: true,
    },
    fields: {
      default: () => {
        return [];
      },
    },
    multi: {
      default: false,
    },
    current: {
      default: "",
    },
    multiAdsCat: {
      default: false,
    },
    editField: {
      type: Object,
      default: () => {
        return {};
      },
    },
    auto_change: {
      default: false,
      require: true,
    },
  },

  data() {
    return {
      parameters: {
        Contact_CallEnabled: { boolean: { value: true } },
        Contact_ChatEnabled: { boolean: { value: true } },
        Contact_CallMethod: { str: { value: "DIRECT_CALL" } },
      },
      errorMessage: "",
      selectedOption: "DIRECT_CALL",
      rules: [(v) => !!v || "این فیلد الزامی است"],
      selected_numbers: "",
      properties: [],
      auto: [],
      Ads: [],
      city: "",
      productMessage: "",
      defaultTitle: false,
      getText: false,
      suggestText: false,
      expireTime: "",
      defaultDesc: false,
      auto_changes: this.auto_change,
      multiFiltered: [],
      suggestTexts: {
        titles: null,
        descriptions: null,
      },
      checkphone: null,
      singleFiltered: [],
      titleEmojies: [
        "%",
        "٪",
        "*",
        "×",
        "،",
        ".",
        "-",
        "+",
        "«",
        "»",
        "&",
        "'",
        "(",
        ")",
        "/",
      ],
      descEmojies: [
        "✌️",
        "✅",
        "♻️",
        "❎",
        "✳️",
        "❇️",
        "✔️",
        "☑️",
        "⚫",
        "⚪",
        "▪️",
        "▫️",
        "◾",
        "◽",
        "◼️",
        "◻️",
        "⬛",
        "⬜",
        "♾️",
        "✖️",
        "➗",
        "➖",
        "➕",
        "↩️",
        "↪️",
        "⤵️",
        "⤴️",
        "↔️",
        "↕️",
        "↖️",
        "↙️",
        "↘️",
        "↗️",
        "⬇️",
        "⬆️",
        "⬅️",
        "➡️",
        "◀️",
        "⏬",
        "⏫",
        "⏪",
        "⏩",
        "*️⃣",
        "#️⃣",
      ],
      titleValue: "",
      texts: [],
      textsDesc: [],
      descriptionValue: "",
      loading: false,
      iconIndex: 0,
      inputs: {
        string: VTextField,
        TextFieldWidget: VTextField,
        number: VTextField,
        hierarchy_widget: VSelect,
        SingleSelectHierarchyWidget: VSelect,
        // "SegmentedControlFieldWidget":callMethod,
        select: VAutocomplete,
        textarea: VTextarea,
        boolean: VSwitch,
        boolean: VCheckbox,
        // "hidden": VHidden,
        array: VAutocomplete,
        object: VAutocomplete,
        checkboxes: VAutocomplete,
        // videos: videoUploadHandler,
      },
      inputTypes: {
        I_SEGMENTED_BUTTON_ROW: VSelect,
        I_SINGLE_SELECT_HIERARCHY_ROW: CategoryPicker,
        I_MULTI_SELECT_HIERARCHY_ROW: CategoryPicker,
        I_SINGLE_SELECT_ROW: VAutocomplete,
        I_NUMBER_FIELD_ROW: VTextField,
        I_TEXT_FIELD_ROW: VTextField,
        I_CHECKBOX_ROW: VCheckbox,
        I_CHECKBOX_LIST: VSelect,
        I_NUMBER_RANGE_ROW: InputRangePicker,
        OTPField: OTPPicker,
        Description: VTextarea,
        // I_RADIO_ROW: VRadio,
        // I_VIDEO_ROW: videoUploadHandler,
      },
      icons: ["mdi-emoticon", "mdi-emoticon-angry", "mdi-emoticon-excited"],
      emoji: false,
      emojidesc: false,
      jobKeyword: "",
      parameters: this.param,
      timer: null,
      queryString: new URLSearchParams(),
    };
  },
  // destroyed() {
  //   Bus.$off("selected_numbers");
  // },
  mounted() {
    this.parameters.Contact_ChatEnabled = { boolean: { value: true } };
    this.parameters.Contact_CallEnabled = { boolean: { value: true } };
    this.properties = this.fields.map((item) => this.getProperty(item));

    if (Object.keys(this.editField).length > 0) {
      this.editForm();
    }
    this.getTitles();
    this.getTitlesAds();
    console.log(this.selected_numbers, "this.selected_numbers");
    Bus.$on("selected_numbers", (value) => {
      this.selected_numbers = value;
    });
    console.log(this.selected_numbers, "this.selected_numbers");

    Bus.$on("category-multi-filtered", (multiFiltered) => {
      this.multiFiltered = multiFiltered;
    });

    Bus.$on("category-single-filtered", (singleFiltered) => {
      this.singleFiltered = singleFiltered;
    });
    Bus.$on("category-current", (cuurent) => {
      this.current = cuurent;
    });
    Bus.$on("cityInfo", (value) => {
      this.city = value.city;
      this.neighborhood = value.neighborhood;
    });

    setInterval(() => {
      this.getCookie("timer");
    }, 1000);
    this.$forceUpdate();
  },

  computed: {
    fieldCashed() {
      return this.fields;
    },
    contactField() {
      return {
        name: "Contact_CallMethod",
        field_type: "I_RADIO_ROW",
        type: "str",
        placeholder: null,
        hint: "",
        reload: false,
        required: true,
        options: [
          {
            value: "DIRECT_CALL",
            display: `تماس و پیامک با ${
              this.selected_numbers ? this.selected_numbers : "شما"
            }`,
            // description: "شمارهٔ شما روی آگهی نمایش داده می‌شود.",
          },
          {
            value: "SECURE_CALL",
            display: "تماس ناشناس از شمارهٔ واسط دیوار",
            // description: "شمارهٔ شما روی آگهی نمایش داده نمی‌شود.",
          },
        ],
        default: "DIRECT_CALL",
        visibility_condition: [
          {
            key: "Contact_CallEnabled",
            conditions: [true],
          },
        ],
      };
    },
    icon() {
      return this.icons[this.iconIndex];
    },
  },

  watch: {
    titleValue(value) {
      const count = (value.match(/[%٪\*×،\.\-\+«»&'\(\)\/]/g) || []).length;
      const title = this.properties.find((x) => x.name === "title");

      if (count > 4 || value.match("#")) {
        title.errorMessage =
          "عنوان آگهی تنها می‌تواند شامل حروف الفبا، اعداد و 4 نوع از علامت‌های % ٪ * × ، . - + « » & ' ( ) / باشد";
        this.iconIndex = 1;
      } else {
        title.errorMessage = "";
      }
    },
    descriptionValue(value) {
      const descriptions = this.properties.find(
        (x) => x.name === "description"
      );
      if (value.length >= 10) {
        descriptions.errorMessage = "";
      }
    },
    parameters: {
      handler(newVal) {
        if (
          newVal.Contact_CallEnabled?.boolean?.value !== undefined ||
          newVal.Contact_ChatEnabled?.boolean?.value !== undefined
        ) {
          this.validateContactMethods();
          this.$forceUpdate();
        }
      },
      deep: true,
    },
    selectedOption(newValue) {
      this.parameters.ContactCallMethod = { str: { value: newValue } };
      this.validateContactMethods();
    },
    fields() {
      this.properties = [];

      let props = [];
      this.checkphone = this.fields[this.fields.length - 1];
      this.fields.forEach((item) => {
        if (item.field_type?.toLowerCase() === "hidden")
          this.reload(false, item.default, item.name, item.type, item);
        else if (props.findIndex((p) => p.name === item.name) < 0)
          props.push(this.getProperty(item));
      });

      this.properties = props;
      Bus.$emit("properties", props);
      this.$forceUpdate();
    },
    parameters: {
      handler: function () {
        Bus.$emit("parameters", this.parameters);
      },
      deep: true,
    },
    jobKeyword: function (value) {
      this.keyWord = value;
      const sillabels = this.keyWord.split(" ").filter((x) => x);

      if (sillabels.length < 2) {
        this.productMessage = "حداقل 2 کلمه باید وارد شود";
      } else if (sillabels.length >= 5) {
        this.productMessage = "حداکثر 4 کلمه باید وارد شود";
      } else {
        this.productMessage = "";
      }
    },
    expireTime(val) {
      if (val === 0) {
        this.jobKeyword = "";
      }
      if (val <= 0) {
        this.expireTime = "";
      }
    },
  },

  methods: {
    validate() {
      if (this.current === "") {
        this.$modal.error("خطا!", "لطفا دسته موردنظرتان را انتخاب کنید.");
        return false;
      }
      let validate = true;

      const link = this.properties.find((x) => x.label === "لینک وب‌سایت");
      if (!!link) {
        link.required = false;
        link.errorMessage = "";
      }
      const video = this.properties.find((x) => x.name === "Videos");
      if (!!video) {
        video.required = false;
        video.errorMessage = "";
      }
      this.properties
        .filter((x) => x.required === true)
        .forEach((x) => {
          if (
            this.parameters[x.name] ||
            !this.evaluateVisibilityConditions(x.visibility_condition)
          ) {
            validate = validate && true;
          } else {
            x.errorMessage =
              "واردکردن فیلد " + " «" + x.label + "» " + "الزامی است.";
            validate = false;
          }
        });

      validate = validate && this.validateContactMethods();

      if (!this.$refs.forminputMarker.validate())
        this.$modal.error("خطا!", "لطفا فیلدهای الزامی را وارد کنید.");

      return validate;
    },
    validateContactMethods() {
      const callEnabled = this.properties.find(
        (x) => x.name === "Contact_CallEnabled"
      );
      const chatEnabled = this.properties.find(
        (x) => x.name === "Contact_ChatEnabled"
      );
      const callMethod = this.properties.find(
        (x) => x.name === "Contact_CallMethod"
      );
      const isCallEnabled = this.parameters.Contact_CallEnabled?.boolean?.value;
      const isChatEnabled = this.parameters.Contact_ChatEnabled?.boolean?.value;
      let valid = true;

      if (!isCallEnabled && !isChatEnabled) {
        this.$set(
          callEnabled,
          "errorMessage",
          "حداقل یک روش تماس را انتخاب کنید."
        );
        // this.$set(
        //   chatEnabled,
        //   "errorMessage",
        //   "حداقل یک روش تماس را انتخاب کنید."
        // );

        valid = false;
      } else {
        this.$set(chatEnabled, "errorMessage", "");
        this.$set(callEnabled, "errorMessage", "");
      }

      if (isCallEnabled && !this.parameters.Contact_CallMethod?.str?.value) {
        this.parameters["Contact_CallMethod"] = {
          ["boolean"]: { value: this.selectedOption },
        };
      } else if (callMethod) {
        this.$set(callMethod, "errorMessage", "");
      }

      return valid;
    },
    // validateContactMethods() {
    //   const callEnabled = this.properties.find(
    //     (x) => x.name === "Contact_CallEnabled"
    //   );
    //   const chatEnabled = this.properties.find(
    //     (x) => x.name === "Contact_ChatEnabled"
    //   );
    //   const callMethod = this.properties.find(
    //     (x) => x.name === "Contact_CallMethod"
    //   );
    //   const isCallEnabled = this.parameters.Contact_CallEnabled?.boolean?.value;
    //   const isChatEnabled = this.parameters.Contact_ChatEnabled?.boolean?.value;
    //   let valid = true;
    //   if (!isCallEnabled && !isChatEnabled) {
    //     chatEnabled.errorMessage = "حداقل یک روش تماس را انتخاب کنید.";
    //     callEnabled.errorMessage = "حداقل یک روش تماس را انتخاب کنید.";
    //     valid = false;
    //   } else {
    //     chatEnabled.errorMessage = "";
    //     callEnabled.errorMessage = "";
    //     this.$forceUpdate();
    //   }
    //   if (isCallEnabled && !this.parameters.Contact_CallMethod?.str?.value) {
    //     this.parameters["Contact_CallMethod"] = {
    //       ["boolean"]: { value: this.selectedOption },
    //     };
    //   } else if (callMethod) {
    //     callMethod.errorMessage = "";
    //   }
    //   return valid;
    // },
    getProperty(key) {
      const name = key.name;
      const min = key.min;
      const max = key.max;
      const help = key.placeholder;
      const requireField = key.required;
      const placeholder = key.placeholder;
      // const autoReload = key.auto_refresh;
      const has_field = key.fields;
      const defaults = key.default;
      // let items = [];
      let type =
        key.name === "OTPField"
          ? "OTPField"
          : key.name === "Description"
          ? "Description"
          : key.field_type ?? (key.type !== "integer" ? key.type : "number");
      let title = key.title;
      let itemValue = key.enum ?? [];
      // let itemText = key.enumNames ?? itemValue;

      let field_type = key.type;
      let options =
        key.options instanceof Array
          ? key.options.map((item) => {
              return {
                key: item.value,
                lable: item.display,
              };
            })
          : key.options?.children || [];
      let visibility_condition = key.visibility_condition;
      let reload = key.reload;
      let val = null;

      if (name === "Contact_CallEnabled" || name === "Contact_ChatEnabled") {
        val = true;
      } else {
        switch (key.type) {
          case "str":
          case "repeated_string":
            val = key.default ?? "";
            break;

          case "boolean":
            val =
              key.name === "Contact_CallEnabled" ||
              key.name === "Contact_ChatEnabled"
                ? true
                : Boolean(key.default) ?? true;
            break;
          case "hidden":
            val = key.default ?? "";
            break;
          case "video":
            val = key.default ?? "";
            break;

          case "integer":
            val = Number(key.default) ?? 0;
            break;
          default:
            val = "";
        }
      }
      if (
        key.name === "Contact_CallEnabled" ||
        key.name === "Contact_ChatEnabled"
      ) {
        val = true;
      }
      // if (key.name === "Contact_CallEnabled") {
      //   key.options = this.checkphone.options.map((item) => {
      //     return {
      //       key: item.value,
      //       lable: item.display,
      //     };
      //   });
      // }

      // itemValue.forEach((item, index) => {
      //   items.push({
      //     key: item,
      //     lable: itemText[index]
      //   })
      // })

      if (Object.keys(this.editField).length > 0) {
        if (this.timer != null) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
          this.current = this.editField.category;
          this.editForm();
          this.parameters = this.param;

          this.timer = null;
        }, 500);
      }

      return {
        component: this.inputTypes[type],
        label: title,
        counter: max ? max : null,
        hint: help ? help : null,
        // items: items,
        items: options,
        name: name,
        min: min,
        value: val,
        required: requireField,
        placeholder: placeholder,
        has_fields: has_field,
        errorMessage: "",
        // autoReload: autoReload,
        rules: [
          (v) => {
            if (name === "title" || name === "description")
              return (
                (this.required === true ? v < max : v.length <= max) ||
                "مقدار وارد شده بیش از حد مجاز است.حداکثر مقدار موردنیاز " +
                  max +
                  " است."
              );
            // else if (["boolean", "select", "string", "object", "number", "array", "hidden", "radio", "SingleSelectHierarchyWidget", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
            else return true;
          },
          (v) => {
            if (name === "title" || name === "description")
              return (
                (this.required === true ? v > min : v.length >= min) ||
                "مقدار وارد شده کمتر از حد مجاز است.حداقل مقدار موردنیاز  " +
                  min +
                  " است."
              );
            // else if (["boolean", "select", "object", "string", "number", "array", "hidden", "number", "radio", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
            else return true;
          },
          // (v) => {
          //   if (name === "Videos" && v && v.length > 1) {
          //     return "تعداد ویدیوهای انتخاب‌شده نباید بیشتر از ۱ باشد.";
          //   }
          //   return true;
          // },
          (v) => {
            if (
              (name === "Contact_ChatEnabled" ||
                name === "Contact_CallEnabled") &&
              !this.parameters["Contact_ChatEnabled"]?.boolean?.value &&
              !this.parameters["Contact_CallEnabled"]?.boolean?.value &&
              !v
            ) {
              return "حداقل یک روش تماس را انتخاب کنید.";
            }
            return true;
          },
        ],
        icons: [
          {
            icon: "mdi-emoticon"
              ? title === "عنوان آگهی" || title === "توضیحات آگهی"
                ? this.icon
                : "fas fa-pencil-alt"
              : this.icon,
            click: () => {
              if (title === "عنوان آگهی") this.emoji = true;
              else if (title === "توضیحات آگهی") this.emojidesc = true;
              else return false;
            },
          },
          {
            icon: "mdi-emoticon"
              ? title === "عنوان آگهی" || title === "توضیحات آگهی"
                ? "fa fa-edit"
                : ""
              : "fa fa-edit",
            click: () => {
              if (title === "عنوان آگهی") {
                this.defaultTitle = true;
              } else if (title === "توضیحات آگهی") {
                this.defaultDesc = true;
              }
            },
          },
          {
            icon: "mdi-emoticon"
              ? title === "عنوان آگهی"
                ? "fa fa-check"
                : ""
              : "mdi-emoticon",
            click: () => {
              this.getText = true;
              this.getCookie("timer");
            },
          },
        ],
        type: type,
        field_type,
        visibility_condition,
        reload,
      };
    },
    evaluateVisibilityConditions(visibilityConditions) {
      if (!visibilityConditions || !visibilityConditions.length) return true;

      return visibilityConditions
        .map((vc) => {
          const property = this.properties.find((p) => p.name === vc.key);
          const key = this.parameters[vc.key];

          if (!property || !key) return true;

          return (
            property &&
            key &&
            vc.conditions.includes(key[property.field_type].value)
          );
        })
        .every((item) => !!item);
    },
    getValue(title, value, name, type) {
      if (title === "عنوان آگهی") {
        this.itemType = title;
        this.titleValue = value;
      } else if (title === "توضیحات آگهی") {
        this.descriptionValue = value;
      }

      this.properties.find((x) => x.name === name).errorMessage = "";

      if (type === "I_NUMBER_RANGE_ROW") {
        this.parameters[name] = {
          object: { value: value },
        };
      } else {
        this.parameters[name] = {
          [type]: {
            value:
              type === "boolean"
                ? Boolean(value)
                : type === "number"
                ? Number(value)
                : value,
          },
        };
      }
    },
    emojiPicker(element) {
      const $title = $('[name = "title"]')[0];

      let currentInput = this.titleValue;
      let cursorPos = $title.selectionStart;
      let textBefore = currentInput.substring(0, cursorPos);
      let textAfter = currentInput.substring(cursorPos, currentInput.length);

      this.titleValue =
        textBefore + $(element.target).data("emoji") + textAfter;
      this.properties.find((x) => x.name === "title").value = this.titleValue;

      this.$nextTick(function () {
        $title.focus();
        $title.setSelectionRange(cursorPos, cursorPos);
      });
    },
    emojiPickerdesc(element) {
      const $title = $('[name = "description"]')[0];

      let currentInput = this.descriptionValue;
      let cursorPos = $title.selectionStart;
      let textBefore = currentInput.substring(0, cursorPos);
      let textAfter = currentInput.substring(cursorPos, currentInput.length);

      this.descriptionValue =
        textBefore + $(element.target).data("emoji") + textAfter;
      this.properties.find((x) => x.name === "description").value =
        this.descriptionValue;

      this.$nextTick(function () {
        $title.focus();
        $title.setSelectionRange(cursorPos, cursorPos);
      });
    },
    generateQueryString(key, value) {
      this.queryString.delete(key);
      this.queryString.append(key, value);
    },
    reload(isAutoReload, value, name, type, item) {
      switch (item.field_type) {
        case "str":
        case "repeated_string":
        case "boolean":
        case "hidden":
        case "video":
          this.parameters[name] = {
            [item.field_type]: { value },
          };
          break;

        case "integer":
          this.parameters[name] = {
            [item.field_type]: { value: Number(value) },
          };
          break;
      }
      this.parameters["Contact_CallMethod"] = {
        ["boolean"]: { value: this.selectedOption },
      };
      // this.parameters.push({
      //   Contact_CallMethod: { ["boolean"]: { value: this.selectedOption } },
      // });
      this.$forceUpdate();
      const property = this.properties.find((p) =>
        p.visibility_condition.map((vc) => vc.key).includes(name)
      );

      if (
        !!property &&
        !this.evaluateVisibilityConditions(property.visibility_condition)
      )
        delete this.parameters[property.name];

      // switch (type) {
      //   case "boolean":
      //     const bol = Boolean(value);
      //     if (bol)
      //       this.parameters[name] = bol;
      //     break;
      //   case "number":
      //     this.parameters[name] = Number(value);
      //     break;
      //   default:
      //     this.parameters[name] = value;
      //     break;
      // }

      this.generateQueryString(name, value);

      if (!!isAutoReload && !!this.current) {
        $.ajax({
          url: `${url}/divar/categories/${this.current}/dependency`,
          method: "POST",
          dataType: "json",
          data: JSON.stringify(this.parameters),
          fn: this.reload,
          params: [isAutoReload, value, name, type],
          headers: {
            Authorization: Token,
            "Content-Type": "application/json",
            ACCEPT: "application/json",
          },
          success: (data) => {
            const response =
              this.multiAdsCat === true
                ? data.data.filter((x) => !this.multiFiltered.includes(x.name))
                : data.data.filter((x) => !this.singleFiltered[x.name]);
            console.log(response, "response");
            Bus.$emit("reload", response);
          },
        });
      }
    },
    editForm() {
      this.queryString.forEach((value, key) => {
        this.queryString.delete(key);
      });

      Object.keys(this.editField).forEach((key) => {
        if (typeof this.editField[key] != "object")
          this.queryString.set(key, this.editField[key]);
      });
      this.titleValue = this.editField.title;
      this.descriptionValue = this.editField.description;
      if (!this.editField.Contact_CallEnabled) {
        this.parameters.Contact_CallEnabled = { boolean: { value: true } };
      }
      if (!this.editField.Contact_ChatEnabled) {
        this.parameters.Contact_ChatEnabled = { boolean: { value: true } };
      }
      if (this.current === "") return;

      $.ajax({
        url: `${url}/divar/categories/${this.current}/dependency`,
        type: "POST",
        dataType: "json",
        fn: this.editForm,
        data: JSON.stringify(this.parameters),
        headers: {
          Authorization: Token,
          ACCEPT: "application/json",
          "Content-Type": "application/json",
        },
        success: (data) => {
          Object.keys(this.editField).forEach((key) => {
            let item = this.properties.find((x) => x.name === key);
            if (typeof this.editField[key] != "object") {
              if (item)
                this.properties.find((x) => x.name === key)["value"] =
                  this.editField[key];
            }
          });
        },
      });
    },
    allowOnlyNumbers(value, name, type) {
      if (type === "number") {
        let allowedKeys = [8, 46, 38, 40, 37, 39];
        const keypressed = value.which || value.keyCode;
        if (/[^0-9\s]+/.test(value.key)) {
          if (allowedKeys.every((e) => e !== keypressed)) {
            value.preventDefault();
          }
        } else return true;
      }
    },
    enableCounter(name) {
      if (name === "title") {
        return 50;
      } else if (name === "description") {
        return 1000;
      } else return false;
    },
    isRequire(requirement) {
      if (requirement === true) {
        return true;
      } else return false;
    },
    getTitles() {
      $.ajax({
        url: `${url}/default/text/all`,
        method: "GET",
        fn: this.getTitles,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        success: (data) => {
          this.texts = data;
          this.textsDesc = data;
        },
      });
    },
    setTitle(e) {
      this.properties.find((x) => x.name === "title")["value"] = e;
      this.titleValue = e;
      this.parameters["title"] = this.titleValue;
      this.defaultTitle = false;
    },
    setDescription(e) {
      this.properties.find((x) => x.name === "description")["value"] = e;
      this.descriptionValue = e;
      this.parameters["description"] = this.descriptionValue;
      this.defaultDesc = false;
    },
    getTitlesAds() {
      $.ajax({
        url: `${url}/default/own/all`,
        method: "GET",
        fn: this.getTitles,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        success: (data) => {
          this.Ads = data;
        },
      });
    },
    authenticate() {
      this.$modal.showLoading();
      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.authenticate,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-type": "application/json",
        },
        data: JSON.stringify({
          title: this.titleValue,
          city: String(this.city),
          category: this.current,
        }),
        msg: false,
        error: (data) => {
          if (data.status === 422) {
            this.$modal.error("خطا", "لطفا اطلاعات فرم را کامل نمایید.");
          } else {
            this.$modal.error("خطا", "عنوان مورد نظر قابل قبول نمی باشد.");
          }
        },
        success: (data) => {
          this.$nextTick(function () {
            this.$modal.success(data.message);
          });
        },
      });
    },
    getSuggest() {
      this.$modal.showLoading();
      if (this.expireTime === "") {
        Axios2.post(
          "/shop/default",
          JSON.stringify({
            category: this.current,
            city: this.city === "" ? String(1) : String(this.city),
            keyword: this.jobKeyword,
            length: 10,
          })
        )
          .then((response) => {
            this.$modal.hideLoading();
            if (response.data.data.length <= 0) {
              this.$modal.error(
                "خطا!",
                "اطلاعات آگهی و یا نام محصول صحیح نیست."
              );
            } else {
              localStorage.removeItem("suggestions");
              this.suggestTexts.titles = response.data.data.map((x) => x.title);
              this.suggestTexts.descriptions = response.data.data.map(
                (x) => x.description
              );
              // this.setCookies('timer', 'time', 10);
              localStorage.setItem("suggestions", response.data.data);
            }
          })
          .catch((error) => {
            this.$modal.error("خطا!", "لطفا اطلاعات فرم را تکمیل فرمایید!");
          });
      } else
        this.$modal.info(
          "هشدار!",
          "تاپایان زمان باقی مانده شما قادر به ایجاد درخواست جدید نیستید."
        );
    },
    delOptions() {
      this.getText = false;
      if (
        this.titleValue != null ||
        this.titleValue !== "" ||
        this.titleValue !== undefined
      )
        this.suggestTexts.titles.splice(
          this.suggestTexts.titles.indexOf(this.titleValue),
          1
        );

      if (
        this.descriptionValue != null ||
        this.descriptionValue !== "" ||
        this.descriptionValue !== undefined
      )
        this.suggestTexts.descriptions.splice(
          this.suggestTexts.descriptions.indexOf(this.descriptionValue),
          1
        );
    },
    setCookies(key, value, min) {
      const d = new Date();
      d.setTime(d.getTime() + min * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = key + "=" + value + ";" + expires + ";path=/";
      document.cookie = key + "_expire=" + expires.replace("expires=", "");
    },
    getCookie(key) {
      let cookies = document.cookie.split(";");
      let now = new Date();

      let newCookies = cookies
        .filter((item) => item.indexOf("_expire") > -1)
        .map((item) => {
          let expire_cookie = item.trim().split("=");
          let cookie =
            cookies
              .find(
                (x) =>
                  x.indexOf(expire_cookie[0].replace("_expire", "") + "=") > -1
              )
              ?.trim()
              ?.split("=") || [];
          let expire = new Date(expire_cookie[1]);
          this.expireTime = parseInt(
            expire.getTime() / 1000 - now.getTime() / 1000
          );

          return {
            name: expire_cookie[0].replace("_expire", ""),
            value: cookie[1] || null,
            expire_at: parseInt(expire.getTime() / 1000 - now.getTime() / 1000),
          };
        });

      return newCookies.find((item) => item.name === key);
    },
  },
};
</script>
<style>
.fa-pencil-alt {
  font-size: 17px !important;
}

.font-20 {
  font-size: 16pt;
}

.symbol {
  border: 2px solid rgba(255, 255, 255, 0.45);
  min-width: 3rem !important;
  max-width: 3rem !important;
  min-height: 2rem !important;
  max-height: 3rem !important;
  text-align: center;
  box-shadow: -5px -5px 9px rgba(255, 255, 255, 0.45),
    5px 5px 9px rgba(94, 104, 121, 0.3);
  background-color: rgba(255, 255, 255, 0.45);
  color: #1c0152;
}

.symbol:hover {
  box-shadow: -5px -5px 9px rgba(255, 255, 255, 0.45),
    5px 5px 9px rgba(94, 104, 121, 0.3);
  transition-delay: 0.1s;
  color: #1c0152;
}
</style>
